import { AnyAction } from "@reduxjs/toolkit";
import { map, mergeMap } from "rxjs/operators";

import { parseServerError } from "@tsp/api/utils/parseServerError";
import { Epic, combineEpics, ofAction } from "@tsp/utils/epics";
import { catchAsyncError } from "@tsp/utils/epics/catchAsyncError";

import { notifierSlice, showNotification } from "@tsp-core/notifier/slice";

import { EnvSegment } from "../env";

import { linkAccount, setDefaultAccount } from "./actions";
import { PayoutEpicDependencies } from "./interface";

type State = EnvSegment;

export const linkAccountEpic: Epic<State, PayoutEpicDependencies> = (actions$, state$, deps) =>
  actions$.pipe(
    ofAction(linkAccount.started),
    mergeMap((action) => {
      const { contractorAccount } = action.payload;

      return deps.api.getLinkAccountUrl({ contractorAccount }).pipe(
        map((response) =>
          linkAccount.done({
            result: response,
            params: action.payload,
          }),
        ),
        catchAsyncError((error) =>
          linkAccount.failed({
            error: parseServerError(error),
            params: action.payload,
          }),
        ),
      );
    }),
  );

export const openAccountLink: Epic = (actions$) =>
  actions$.pipe(
    ofAction(linkAccount.done),
    mergeMap((action) => {
      window.location.href = action.payload.result.link;
      return [];
    }),
  );

const errorNotificationEpic: Epic = (actions$) =>
  actions$.pipe(
    ofAction(setDefaultAccount.failed, linkAccount.failed),
    map(
      (action) =>
        showNotification({
          type: "error",
          message: action.payload.error,
        }) as unknown as AnyAction,
    ),
  );

export const payoutEpic = combineEpics(linkAccountEpic, openAccountLink, errorNotificationEpic);
